module.exports = __webpack_public_path__ + "static/img/qrcode.73e29a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/qrcode.png
// module id = Euvc
// module chunks = 7